import { remoteLogErrorHandler } from 'gje-error-handler';
import endpoint from '../endpoint';

export default remoteLogErrorHandler({
    endpoint: `/${endpoint}/api/clientLog`
});
